import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../state/store';
import { Transaction } from '../../../models';

type TransactionsUiState = {
  sidebar: {
    transaction?: Transaction;
    open: boolean;
  };
};

const initialState: TransactionsUiState = {
  sidebar: {
    open: false,
  },
};

export const transactionsUiSlice = createSlice({
  name: 'transactionsPage',
  initialState,
  reducers: {
    selectTransaction: (state, action: PayloadAction<Transaction>) => {
      state.sidebar.transaction = action.payload;
      state.sidebar.open = true;
    },
    unselectTransaction: (state) => {
      state.sidebar.transaction = undefined;
      state.sidebar.open = false;
    },
  },
});

export const { selectTransaction, unselectTransaction } =
  transactionsUiSlice.actions;

export const getSidebarTransaction = (state: RootState) =>
  state.transactionsUiState.sidebar.transaction;

export const isTransactionsSidebarOpen = (state: RootState) =>
  state.transactionsUiState.sidebar.open;
